import { render, staticRenderFns } from "./Gazopen.vue?vue&type=template&id=2d909657&"
import script from "./Gazopen.vue?vue&type=script&lang=js&"
export * from "./Gazopen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports